import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../library/store/authentication';
import { useHistory } from 'react-router-dom';

export default function LogoutPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(logout());


    history.push('/login');
  }, [dispatch, history]);

  return null; // No UI needed for logout
}